define([
    "dojo/_base/declare",
    "csi/breadcrumb/StateActionController",
    "./PriceListActionMixin"
], function(declare,StateActionController,PriceListActionMixin) {

    return declare([StateActionController, PriceListActionMixin], {
        
        m_operation: "RevertToDraftPriceList"
        
    });
});